import { useEffect } from "react";

const Logout=()=>
{
    useEffect(()=>{});
    return(
        <>

        </>
    );
}
export default Logout;